import { render } from "./mobile-view.vue?vue&type=template&id=5f0fb473&scoped=true"
import script from "./mobile-view.vue?vue&type=script&lang=js"
export * from "./mobile-view.vue?vue&type=script&lang=js"

import "./mobile-view.vue?vue&type=style&index=0&id=5f0fb473&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0fb473"]])

export default __exports__